import axios from 'axios'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import '../Styles/Movement.css'
import Rodal from 'rodal'
import 'rodal/lib/rodal.css'
import ViewportMeta from '../../../utils/ViewportMeta'
import { useTranslation } from 'react-i18next'
import Sidebarfats from '../../../components/sidebar/Sidebarfats'

const AssetMovement = () => {
  //Popup New Request Screen
  const [visible, setVisible] = useState(false)
  const { t, i18n } = useTranslation()

  const show = () => {
    setVisible(true)
  }

  const hide = () => {
    setVisible(false)
  }

  const HandleSubmit = e => {
    e.preventDefault()
  }

  const navigate = useNavigate()
  return (
    <>
      <div className={`p-0 h-full ${i18n.language === 'ar' ? 'sm:mr-72' : 'sm:ml-72'}`}  >
       
          <ViewportMeta />
          {/* // creae excel like Tables  */}
          <div
            className={`table-container-generate  ${i18n.language === 'ar' ? 'direction-rtl' : 'direction-ltr'
              }`}
          >
            <table>
              <thead>
                <tr>
                  <th>{t('REQUEST NO')}</th>
                  <th>{t('TYPE OF REQUEST')}</th>
                  <th>{t('DATE REQUEST')}</th>
                  <th>{t('MAKER')}</th>
                  <th>{t('USER LOGIN')}</th>
                  <th>{t('APPROVAL DEPARTMENT')}</th>
                  <th>{t('CHECKER')}</th>
                </tr>
              </thead>
              <tbody>
                {/* {data.length > 0 && 
            data.map((item) => {
              return (
                <tr>
                  <td>{item.QTY}</td>
                  <td>{item.MajorCategory}</td>
                  <td>{item.MajorCategoryDescription}</td>
                  <td>{item.MInorCategory}</td>
                  <td>{item.MinorCategoryDescription}</td>
                  <td>{item.TagNumber}</td>
                  <td>{item.sERIALnUMBER}</td>
                  <td>{item.Manufacturer}</td>
                  <td>{item.ModelofAsset}</td>
                  <td>{item.UserLoginID}</td>
                  <td>{item.aSSETcONDITION}</td>
                </tr>
    
              )
          })
          }  */}
                <tr>
                  <td>Hasnain</td>
                  <td>Hasnain</td>
                  <td>Hasnain</td>
                  <td>Majid</td>
                  <td>Majid</td>
                  <td>Majid</td>
                  <td>Hasnain</td>
                </tr>

                <tr>
                  <td>Hasnain</td>
                  <td>Hasnain</td>
                  <td>Hasnain</td>
                  <td>Majid</td>
                  <td>Majid</td>
                  <td>Majid</td>
                  <td>Hasnain</td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* // creae excel like Tables  */}
          <div
            className={`table-container-generate ${i18n.language === 'ar' ? 'direction-rtl' : 'direction-ltr'
              }`}
          >
            <table>
              <thead>
                <tr>
                  <th>{t('BARCODE TAG NO')}</th>
                  <th>{t('ASSET DESCRIPTION')}</th>
                  <th>{t('OLD LOCATION')}</th>
                  <th>{t('NEW LOCATION')}</th>
                  <th>{t('DATE PICKED')}</th>
                  <th>{t('CITY')}</th>
                  <th>{t('DEPTCODE')}</th>
                  <th>{t('BUSINESS UNIT')}</th>
                  <th>{t('SERIAL NOS')}</th>
                </tr>
              </thead>
              <tbody>
                {/* {data.length > 0 && 
            data.map((item) => {
              return (
                <tr>
                  <td>{item.QTY}</td>
                  <td>{item.MajorCategory}</td>
                  <td>{item.MajorCategoryDescription}</td>
                  <td>{item.MInorCategory}</td>
                  <td>{item.MinorCategoryDescription}</td>
                  <td>{item.TagNumber}</td>
                  <td>{item.sERIALnUMBER}</td>
                  <td>{item.Manufacturer}</td>
                  <td>{item.ModelofAsset}</td>
                  <td>{item.UserLoginID}</td>
                  <td>{item.aSSETcONDITION}</td>
                </tr>
    
              )
          })
          }  */}
                <tr>
                  <td>Hasnain</td>
                  <td>Hasnain</td>
                  <td>Hasnain</td>
                  <td>Majid</td>
                  <td>Majid</td>
                  <td>Majid</td>
                  <td>Majid</td>
                  <td>Hasnain</td>
                  <td>Hasnain</td>
                </tr>

                <tr>
                  <td>Hasnain</td>
                  <td>Hasnain</td>
                  <td>Hasnain</td>
                  <td>Majid</td>
                  <td>Majid</td>
                  <td>Majid</td>
                  <td>Majid</td>
                  <td>Hasnain</td>
                  <td>Hasnain</td>
                </tr>
              </tbody>
            </table>
          </div>

          <Rodal visible={visible} onClose={hide}>
            <div className='mt-6'>
              <form onSubmit={HandleSubmit}>
                <div
                  className={`flex justify-between items-center flex-wrap gap-2 ${i18n.language === 'ar' ? 'direction-rtl' : 'direction-ltr'
                    }`}
                >
                  <label className='text-sm'>{t('Type of Request')}</label>
                  <select className='bg-gray-50 border border-gray-300 text-gray-900 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-[65%] md:p-1 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'>
                    <option>{t('Select Request')}</option>
                    <option>{t('Asset Transfer')}</option>
                  </select>

                  <label className='text-sm'>{t('Date Request')}</label>
                  <input
                    type='date'
                    className='bg-gray-50 border border-gray-300 text-gray-900 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-[65%] md:p-1 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
                  />

                  <label className='text-sm'>{t('Request By')}</label>
                  <input
                    type='text'
                    placeholder='Hasnain'
                    className={`bg-gray-50 border border-gray-300 text-gray-900 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-[65%] p-1.5 md:p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 ${i18n.language === 'ar' ? 'text-end' : 'text-start'}`}
                  />

                  <label className='text-sm'>{t('APPROVAL Dept')}</label>
                  <select className='bg-gray-50 border border-gray-300 text-gray-900 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-[65%] md:p-1 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'>
                    <option>{t('Asset Transfer')}</option>
                  </select>

                  <div className='flex gap-3 mt-2'>
                    <button
                      className='h-8 w-20 bg-blue-500 text-white hover:bg-blue-900 rounded-md'
                      type='submit'
                    >
                      {t('Save')}
                    </button>
                    <button
                      onClick={hide}
                      className='h-8 w-20 bg-blue-500 text-white hover:bg-red-600 rounded-md'
                      type='submit'
                    >
                      {t('Close')}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </Rodal>

          <div className='table-last-part flex justify-between items-center 2xl:h-[60px] xl:h-[60px] lg:h-[60px] md:h-[60px] h-auto gap-2 px-5'>
            <div className='flex flex-wrap justify-center gap-5'>
              <button
                onClick={show}
                className='text-white font-medium bg-blue-700 hover:bg-blue-900 h-10 w-32 rounded-md'
              >
                {t('New Request')}
              </button>
              <button
                onClick={() => navigate(-1)}
                className='text-white font-medium hover:bg-red-500 bg-blue-700 h-10 w-32 rounded-md'
              >
                {t('Cancel')}
              </button>
              <button className='text-white font-medium bg-blue-700 hover:bg-blue-900 h-10 w-32 rounded-md'>
                {t('History')}
              </button>
            </div>

            <div className='flex flex-wrap justify-center gap-5'>
              <button className='text-white font-medium bg-blue-700 hover:bg-blue-900 h-10 w-32 rounded-md'>
                {t('Post')}
              </button>
              <button className='text-white font-medium bg-blue-700 hover:bg-blue-900 h-10 w-32 rounded-md'>
                {t('Preview')}
              </button>
            </div>
          </div>
        </div>
    </>
  )
}

export default AssetMovement
